import {
    Window,
    ComponentManager,
} from 'radpresentation.htmlclient.defaultviewextensions';
import LandesverbandWechselnDialogViewModel from './LandesverbandWechselnDialogViewModel';
import layout from './LandesverbandWechselnDialogWindow.html?raw';

export default class LandesverbandWechselnDialogWindow extends Window
{

    public override viewModel: LandesverbandWechselnDialogViewModel;

    constructor(viewModel: LandesverbandWechselnDialogViewModel) {
        const $element = $('<div>').addClass('lv-wechseln-dialog-wrapper');
        super(viewModel, $element);
        this.applyTemplate(layout, $element);
    }

    protected override getElementToAppended(): JQuery<HTMLElement> {
        return $('[data-region=Modal]');
    }
}

ComponentManager.setControl('LandesverbandWechselnDialog', LandesverbandWechselnDialogWindow, 'ONVHTMLViewExtension');
